import { branch, compose, renderComponent, withHandlers } from 'recompose';
import { connect } from 'react-redux';

import LoansTable from './LoansTable';
import withCurrency from '../../common/hoc/withCurrency';
import withTimezone from '../../auth/utils/withTimezone';
import { getRoleIdType } from '../../auth/selectors';
import { fetchLoansLink } from '../actions';
import { getAvailableLoanLinkType } from '../utils';
import openLinkInNewWindow from '../../common/helpers/openLinkInNewWindow';
import NoLoansFound from './NoLoansFound';

export default compose(
  branch(
    props => !props.loans || !props.loans.length,
    renderComponent(NoLoansFound),
  ),
  withCurrency,
  withTimezone,
  connect(
    state => ({
      shopOrBarber: getRoleIdType(state),
    }),
    { fetchLoansLink }
  ),
  withHandlers({
    onLoanLinkClicked: props => loan => () => {
      props.fetchLoansLink(props.shopOrBarber.id, props.shopOrBarber.type, getAvailableLoanLinkType(loan))
        .then(({ url }) => openLinkInNewWindow(url));
    },
  }),
)(LoansTable);
